export default "__VITE_ASSET__J_AjxTWJ__"